import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {PageBody, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {Outlet} from 'react-router-dom'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {AgendaUrlParams} from '@/features/agenda/types'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {useTranslation} from '@/translations/i18n'
import {AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const AgendaRoute = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const urlParams = useURLParsedParams(AgendaUrlParams)

    if (!permissions?.agenda.read) {
        return <NoPermissionBox />
    }

    return urlParams.success ? (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <PageContent style={{zIndex: 0, padding: 0}}>
                <Outlet context={urlParams.data} />
            </PageContent>
        </PageBody>
    ) : (
        <ErrorBox title={t('errors:invalid_link')} icon={<AlertTriangleIcon />} />
    )
}
